function svgs(svg) {
    const svgVideoPlay =
        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve"><defs> </defs> <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" > <circle cx="45" cy="45" r="45" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(32,196,203); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/> <path d="M 61.749 50.066 L 28.345 75.123 c -1.38 1.035 -3.35 0.05 -3.35 -1.675 V 23.335 c 0 -1.725 1.97 -2.71 3.35 -1.675 l 33.405 25.057 C 62.866 47.554 62.866 49.229 61.749 50.066 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(27,167,173); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" /> <path d="M 65.532 46.283 L 32.127 71.34 c -1.38 1.035 -3.35 0.05 -3.35 -1.675 V 19.552 c 0 -1.725 1.97 -2.71 3.35 -1.675 l 33.405 25.057 C 66.648 43.771 66.648 45.446 65.532 46.283 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" /> </g> </svg>';
    const svgPlay =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18c.62-.39.62-1.29 0-1.69L9.54 5.98C8.87 5.55 8 6.03 8 6.82z"></path></svg>';
    const svgPause =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><line x1="4" y1="3" x2="4" y2="8"></line><line x1="6" y1="3" x2="6" y2="8"></line></svg>';
    const svgArrow =
        '<?xml version="1.0" encoding="UTF-8"?> <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5.15 5.17"> <g id="graphic"> <polygon points="0 0 1.3 2.61 0 5.17 5.15 2.58 0 0"/> </g> </svg>';
    const svgWav =
        '<?xml version="1.0" encoding="UTF-8"?> <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.5 39"><g id="graphic"> <g> <path class="cls-1" d="m.75,38.18c1.41.17,2.84.03,4.19-.42,1.35-.45,2.58-1.2,3.61-2.18.74.82,1.64,1.47,2.65,1.92,1.01.45,2.1.68,3.2.68s2.19-.23,3.2-.68c1.01-.45,1.91-1.1,2.65-1.92.74.82,1.64,1.47,2.65,1.92,1.01.45,2.1.68,3.2.68s2.19-.23,3.2-.68c1.01-.45,1.91-1.1,2.65-1.92,1.02.99,2.26,1.73,3.61,2.18,1.35.45,2.78.59,4.19.42"/> <path class="cls-1" d="m.75,33.48c1.41.17,2.84.03,4.19-.42,1.35-.45,2.58-1.2,3.61-2.18.74.82,1.64,1.47,2.65,1.92,1.01.45,2.1.68,3.2.68s2.19-.23,3.2-.68c1.01-.45,1.91-1.1,2.65-1.92.74.82,1.64,1.47,2.65,1.92,1.01.45,2.1.68,3.2.68s2.19-.23,3.2-.68c1.01-.45,1.91-1.1,2.65-1.92,1.02.99,2.26,1.73,3.61,2.18,1.35.45,2.78.59,4.19.42"/> <path class="cls-1" d="m27.37,28.86c-6.7-1.8-7.4-10.29-6.68-14.73,1.05-6.44,8.21-10.46,13.31-5.86,0-7-13.68-10.65-21.79-4.1C4.11,10.73,7.59,25.36.75,28.86"/> <path class="cls-1" d="m35.37,28.86c-3.81-1.02-4.83-4.89-4.42-7.41.6-3.66,5.29-6.91,8.19-4.29,0-3.37-5.58-5.37-10.09-3.65-4.48,1.72-6.64,7.06-6.64,11.56"/> </g> </g> </svg>';
    const svgAddCircle =
        '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M11 20.625C16.3157 20.625 20.625 16.3157 20.625 11C20.625 5.68426 16.3157 1.375 11 1.375C5.68426 1.375 1.375 5.68426 1.375 11C1.375 16.3157 5.68426 20.625 11 20.625ZM11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM11.0002 3.3C11.3594 3.3 11.6564 3.56698 11.7034 3.91338L11.7098 4.00968V10.2903H17.6236C18.0155 10.2903 18.3332 10.6081 18.3332 11C18.3332 11.3593 18.0663 11.6562 17.7199 11.7032L17.6236 11.7097H11.7098V17.257C11.7098 17.6489 11.3921 17.9667 11.0002 17.9667C10.6409 17.9667 10.3439 17.6997 10.297 17.3533L10.2905 17.257V11.7097H4.37625C3.98431 11.7097 3.66658 11.392 3.66658 11C3.66658 10.6407 3.93356 10.3438 4.27996 10.2968L4.37625 10.2903H10.2905V4.00968C10.2905 3.61773 10.6082 3.3 11.0002 3.3Z" fill="#3F3B3B"></path> </svg>';
    const svgChevron =
        '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M22.0001 16L12.0001 26L10.6001 24.6L19.2001 16L10.6001 7.4L12.0001 6L22.0001 16Z" fill="black"/> </svg>';
    const svgAdd =
        '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M17 15V8H15V15H8V17H15V24H17V17H24V15H17Z" fill="black"/> </svg>';
    const svgSubtract =
        '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M24 15H8V17H24V15Z" fill="black"/> </svg>';
    const svgInfo =
        '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M17 22V14H13V16H15V22H12V24H20V22H17Z" fill="black"/> <path d="M16 8C15.7033 8 15.4133 8.08797 15.1666 8.2528C14.92 8.41762 14.7277 8.65189 14.6142 8.92597C14.5006 9.20006 14.4709 9.50166 14.5288 9.79264C14.5867 10.0836 14.7296 10.3509 14.9393 10.5607C15.1491 10.7704 15.4164 10.9133 15.7074 10.9712C15.9983 11.0291 16.2999 10.9994 16.574 10.8858C16.8481 10.7723 17.0824 10.58 17.2472 10.3334C17.412 10.0867 17.5 9.79667 17.5 9.5C17.5 9.10218 17.342 8.72064 17.0607 8.43934C16.7794 8.15804 16.3978 8 16 8Z" fill="black"/> <path d="M16 30C13.2311 30 10.5243 29.1789 8.22202 27.6406C5.91973 26.1022 4.12532 23.9157 3.06569 21.3576C2.00607 18.7994 1.72882 15.9845 2.26901 13.2687C2.80921 10.553 4.14258 8.05845 6.10051 6.10051C8.05845 4.14258 10.553 2.80921 13.2687 2.26901C15.9845 1.72882 18.7994 2.00607 21.3576 3.06569C23.9157 4.12532 26.1022 5.91973 27.6406 8.22202C29.1789 10.5243 30 13.2311 30 16C30 19.713 28.525 23.274 25.8995 25.8995C23.274 28.525 19.713 30 16 30ZM16 4.00001C13.6266 4.00001 11.3066 4.70379 9.33316 6.02237C7.35977 7.34095 5.8217 9.21509 4.91345 11.4078C4.0052 13.6005 3.76756 16.0133 4.23058 18.3411C4.69361 20.6689 5.83649 22.8071 7.51472 24.4853C9.19296 26.1635 11.3312 27.3064 13.6589 27.7694C15.9867 28.2325 18.3995 27.9948 20.5922 27.0866C22.7849 26.1783 24.6591 24.6402 25.9776 22.6668C27.2962 20.6935 28 18.3734 28 16C28 12.8174 26.7357 9.76516 24.4853 7.51472C22.2348 5.26429 19.1826 4.00001 16 4.00001Z" fill="black"/> </svg> ';
    const resSvg =
        svg === 'icon-arrow'
            ? svgArrow
            : svg === 'icon-wav'
            ? svgWav
            : svg === 'icon-addcircle'
            ? svgAddCircle
            : svg === 'icon-chevron'
            ? svgChevron
            : svg === 'icon-info'
            ? svgInfo
            : svg === 'icon-add'
            ? svgAdd
            : svg === 'icon-subtract'
            ? svgSubtract
            : svg === 'icon-play'
            ? svgPlay
            : svg === 'icon-pause'
            ? svgPause
            : '';
    return `<span class="icon svg-icon ${svg}">${resSvg}</span>`;
}
function VideoEmbedGens() {
    const videoEmbeds = document.querySelectorAll('[video-embeds-ccts]');
    for (const videoEmbed of videoEmbeds) {
        const videoTemplate = videoEmbed.parentNode.parentNode.querySelector(
            '[video-embeds-items]'
        );
        videoTemplate.classList.add('container-group');
        const videoDataArrays =
            videoEmbed.querySelectorAll('[video-embeds-cct]');
        const vidArrays = CollectVideData(videoDataArrays);
        const vidCategories = getUniqueArray(vidArrays, 'category');
        for (const vidCategory of vidCategories) {
            const vidCatArrays = getArrayByKeys(
                vidArrays,
                'category',
                vidCategory
            );
            const sortVideos = vidCatArrays.sort(newest_sort);
            BuildVideoItems(true, vidCategory, videoTemplate, sortVideos);
        }
        const elemSels =
            videoEmbed.parentNode.parentNode.querySelectorAll(
                '[data-selection]'
            );
        const elemSelSorts = videoEmbed.parentNode.parentNode.querySelectorAll(
            '[data-selection-sort]'
        );
        selectionInp(videoTemplate, elemSels);
        selectionSort(videoTemplate, elemSelSorts, videoDataArrays);
        buildVideoPopupContainer();
    }
}
function CollectVideData(videoEmbeds) {
    let cnt = 1;
    const vidArrays = [];
    for (const videoEmbed of videoEmbeds) {
        const category = videoEmbed.getAttribute('data-category');
        const heading = videoEmbed.getAttribute('data-heading');
        const videolink = videoEmbed.getAttribute('data-videolink');
        const content = videoEmbed.getAttribute('data-content');
        const datecreated = videoEmbed.getAttribute('data-datecreated');
        const youtubeId = videolink.split('/').pop();
        const elemYoutubeID = `youtube-${cnt}`;
        vidArrays.push({
            category: category,
            datecreated: datecreated,
            videolink: videolink,
            heading: heading,
            content: content,
            youtubeId: youtubeId,
            elemYoutubeID: elemYoutubeID,
        });
        cnt++;
    }
    return vidArrays;
}
function getUniqueArray(arrays, key) {
    const genNewArrays = [];
    for (const array of arrays) {
        genNewArrays.push(array[key]);
    }
    let unique = genNewArrays.filter((item, i, ar) => ar.indexOf(item) === i);
    return unique;
}
function getArrayByKeys(arrays, key, keyValue) {
    const genNewArrays = [];
    for (const array of arrays) {
        if (array[key] === keyValue) {
            genNewArrays.push(array);
        }
    }
    return genNewArrays;
}
function oldest_sort(a, b) {
    return (
        new Date(a.datecreated).getTime() - new Date(b.datecreated).getTime()
    );
}
function newest_sort(a, b) {
    return (
        new Date(b.datecreated).getTime() - new Date(a.datecreated).getTime()
    );
}
function a2z_sort(a, b) {
    const nameA = a.heading.toUpperCase();
    const nameB = b.heading.toUpperCase();
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }
    return 0;
}
function z2a_sort(a, b) {
    const nameA = a.heading.toUpperCase();
    const nameB = b.heading.toUpperCase();
    if (nameA > nameB) {
        return -1;
    }
    if (nameA < nameB) {
        return 1;
    }
    return 0;
}
function selectionSort(videoTemplate, elems, videoDataArrays) {
    for (const elem of elems) {
        elem.addEventListener('change', (e) => {
            const _this = e.currentTarget;
            const _parent = _this.parentNode.parentNode.parentNode;
            videoTemplate.classList.remove('container-group');
            videoTemplate.innerHTML = '';
            const elemVideos = _parent.querySelectorAll('[video-embeds-items]');
            const vidArrays = CollectVideData(videoDataArrays);
            const vidCategories = getUniqueArray(vidArrays, 'category');
            for (const vidCategory of vidCategories) {
                let sortVideos;
                const vidCatArrays = getArrayByKeys(
                    vidArrays,
                    'category',
                    vidCategory
                );
                if (_this.value === 'oldest') {
                    sortVideos = vidCatArrays.sort(oldest_sort);
                } else if (_this.value === 'newest') {
                    sortVideos = vidCatArrays.sort(newest_sort);
                } else if (_this.value === 'a2z') {
                    sortVideos = vidCatArrays.sort(a2z_sort);
                } else if (_this.value === 'z2a') {
                    sortVideos = vidCatArrays.sort(z2a_sort);
                } else {
                    sortVideos = vidCatArrays;
                    videoTemplate.classList.add('container-group');
                }
                BuildVideoItems(true, vidCategory, videoTemplate, sortVideos);
            }
            return _this.value;
        });
    }
}
function selectionInp(videoTemplate, elems) {
    for (const elem of elems) {
        elem.addEventListener('change', (e) => {
            const _this = e.currentTarget;
            _this.setAttribute('selected', _this.value);
            _this.parentNode.parentNode.parentNode.setAttribute(
                _this.getAttribute('data-attr'),
                _this.value
            );
            e.stopImmediatePropagation();
            return _this.value;
        });
    }
}

function BuildVideoItems(enableTitle, title, videoTemplate, sortVideos) {
    let cnt = 1;
    if (
        title !== '' &&
        title !== undefined &&
        title !== null &&
        enableTitle === true
    ) {
        const elemTitle = document.createElement('div');
        elemTitle.setAttribute('class', 'video-linebreak');
        elemTitle.innerHTML = `<h3 class="title txt-title">${title}</h3>`;
        videoTemplate.append(elemTitle);
    }
    for (const Video of sortVideos) {
        const elemVideo = document.createElement('div');
        const youTubeOptions =
            'autoplay=0&amp;rel=0&amp;showinfo=0&amp;egm=0&amp;showsearch=0&amp;controls=1&amp;modestbranding=1&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fwww.hornsby.nsw.gov.au&amp;widgetid=1';
        const youTubeAttrs =
            'frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"';
        elemVideo.setAttribute('class', 'video-item');
        elemVideo.innerHTML += `<iframe id="${Video.elemYoutubeID}" class="bx-item" frameborder="0" title="${Video.heading}" src="https://www.youtube.com/embed/${Video.youtubeId}?${youTubeOptions}" content="${Video.content}" ${youTubeAttrs}></iframe>`;
        elemVideo.innerHTML += `<p class="small txt-date">${Video.datecreated}</p>`;
        elemVideo.innerHTML += `<h5 class="heading">${Video.heading}</h5>`;
        elemVideo.innerHTML += `<div class="btn-video-popup" btn-video-popup youtube-id="${Video.youtubeId}" title="${Video.heading}" content="${Video.content}" disabled></div>`;
        videoTemplate.append(elemVideo);
        videoPopupClick(elemVideo);
        cnt++;
    }
}
function buildVideoPopupContainer() {
    const _body = document.querySelector('body');
    const elemPopup = document.querySelectorAll('[data-video-popup]');
    const elemPopupTemp = document.createElement('div');
    elemPopupTemp.setAttribute('class', 'video-popup');
    elemPopupTemp.setAttribute('data-video-popup', true);
    elemPopupTemp.innerHTML = `<div bg-video-popup></div><div class="video-popup-wrapper" data-video-popup-wrapper></div>`;
    if (elemPopup.length < 1) {
        _body.append(elemPopupTemp);
        btnClickToggle(elemPopupTemp);
    } else if (elemPopup.length > 1) {
        for (let i = 1; i < elemPopup.length; i++) {
            elemPopup[i].remove();
        }
        btnClickToggle(elemPopup[0]);
    }
}
function btnClickToggle(elem) {
    elem.addEventListener('click', (e) => {
        const elemClass = elem.getAttribute('class');
        if (elemClass.indexOf('active') > -1) {
            elem.classList.remove('active');
            elem.classList.add('transitionOut');
            setTimeout(function () {
                elem.classList.remove('transitionOut');
            }, 500);
            const elemPopup = document.querySelector('[data-video-popup]');
            if (typeof elemPopup != 'undefined' && elemPopup != null) {
                const iframeVideo = elemPopup.querySelector('iframe');
                iframeVideo.src = '';
            }
        } else {
            elem.classList.add('transitionIn');
            setTimeout(function () {
                elem.classList.remove('transitionIn');
                elem.classList.add('active');
            }, 500);
        }
    });
}
function videoPopupClick(elem) {
    const elemSeleted = elem.querySelector('[btn-video-popup]');
    elemSeleted.addEventListener('click', (e) => {
        const _this = e.target;
        const _parent = _this.parentNode;
        const youTubeId = _this.getAttribute('youtube-id');
        const youTubeOptions =
            'autoplay=1&amp;rel=0&amp;showinfo=0&amp;egm=0&amp;showsearch=0&amp;controls=1&amp;modestbranding=1&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fwww.hornsby.nsw.gov.au&amp;widgetid=1';
        const youTubeAttrs =
            'frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"';
        const title = _this.getAttribute('title');
        const content = _this.getAttribute('content');
        console.log(youTubeId);
        const elemPopup = document.querySelector('[data-video-popup]');
        elemPopup.classList.add('transitionIn');
        const videoWrapper = elemPopup.querySelector(
            '[data-video-popup-wrapper]'
        );
        videoWrapper.innerHTML = `<div class="video-popup-container"><div class="btn-close" data-btn-close></div><div class="iframe-popup-wrapper"><iframe class="iframe-popup" src="https://www.youtube.com/embed/${youTubeId}?${youTubeOptions}" ${youTubeAttrs} title="${title}"></iframe></div>`;
        videoWrapper.innerHTML += `<a href="https://www.youtube.com/watch/${youTubeId}" target="_blank"><h3 class="title">${title}</h3></a>`;
        if (content !== '' && content !== null && content !== undefined) {
            videoWrapper.innerHTML += `<div class="txt-content-wrapper"><div class="txt-content">${content}</div></div>`;
        }
        videoWrapper.innerHTML += `</div>`;
        setTimeout(function () {
            elemPopup.classList.remove('transitionIn');
            elemPopup.classList.add('active');
        }, 500);
    });
}

function slideCarousel() {
    const svgArrow =
        '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7"> <path fill="#010101" fill-rule="evenodd" d="M6 7l6-5.686L10.613 0 6 4.372 1.387 0 0 1.314 6 7z"/> </svg>';
    const slickOption = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
        prevArrow: `<span class="arrow arrow-prev">${svgArrow}</span>`,
        nextArrow: `<span class="arrow arrow-next">${svgArrow}</span>`,
    };
    const slickCarousel = $('[dynamic-slide-carousel]');
    slickCarousel.slick(slickOption);

    let slickStatus = true;
    const btnStopSclick = document.querySelector(
        '[btn-control-slide-carousel]'
    );
    const elemSvg = document.createElement('div');
    elemSvg.classList = 'icon-container';
    elemSvg.innerHTML = `${svgs('icon-play')}${svgs('icon-pause')}`;
    btnStopSclick.append(elemSvg);
    btnStopSclick.addEventListener('click', (e) => {
        const _this = e.currentTarget;
        if (slickStatus === true) {
            slickCarousel.slick('slickPause');
            slickStatus = false;
            _this.classList.remove('active');
        } else {
            slickCarousel.slick('slickPlay');
            slickStatus = true;
            _this.classList.add('active');
        }
    });
    //btnControl();
    videoSlidePopup();
}
function videoSlidePopup() {
    const videoSlides = document.querySelectorAll(
        '[dynamic-slide-carousel] .slide-carousel'
    );
    for (const videoSlide of videoSlides) {
        const aLink = videoSlide.querySelector('.btn-viewfull');
        const title = aLink.getAttribute('title');
        const content = aLink.getAttribute('content');
        const _parent = aLink.parentNode;
        let youtubeId = '';
        if (
            aLink.href.indexOf('youtube') > -1 ||
            aLink.href.indexOf('youtu.be') > -1
        ) {
            if (aLink.href.indexOf('embed') > -1) {
                youtubeId = aLink.href.split('embed/')[1];
            } else if (aLink.href.indexOf('watch?') > -1) {
                youtubeId = aLink.href.split('watch?v=')[1];
            } else if (aLink.href.indexOf('youtu.be') > -1) {
                const youtubeIds = aLink.href.split(/[\s/]+/);
                youtubeId = youtubeIds[youtubeIds.length - 1];
            }
            const elemVideo = document.createElement('div');
            elemVideo.setAttribute('class', 'btn-video-wrapper');
            elemVideo.innerHTML = `<div class="btn-video-popup btn-viewfull" btn-video-popup youtube-id="${youtubeId}" title="${title}" content="${content}"></div>`;
            videoPopupClick(elemVideo);
            _parent.append(elemVideo);
            aLink.remove();
        }
    }
}
function btnControl() {
    const slideCardHeight = document.querySelector(
        '.slide-listing-cards .inner-container .slide-carousel .figure__image img'
    ).height;
    const btnContainer = document.querySelector(
        '.btn-control-slide-contrainer'
    );
    btnContainer.style.marginTop = `-${btnContainer.offsetHeight}px`;
    btnContainer.style.top = `${slideCardHeight}px`;
}
window.addEventListener(
    'resize',
    function (event) {
        setTimeout(function () {
            btnControl();
        }, 500);
    },
    true
);
slideCarousel();
setTimeout(function () {
    VideoEmbedGens();
}, 1000);
